export const withErrorRecovery =
	<TArgs extends any[], TActionReturn>(
		callback: (...args: TArgs) => Promise<TActionReturn>,
		recoveryCallback: (
			error: unknown,
			...originalArgs: TArgs
		) => TActionReturn | Promise<TActionReturn>,
	) =>
	async (...args: TArgs): Promise<TActionReturn> => {
		try {
			const response = await callback(...args);
			return response;
		} catch (error) {
			return recoveryCallback(error, ...args);
		}
	};
